/**
 * @description
 * Рендерим звезды для рейтинга
 * @param {number} rating - текущий рейтинг
 * @param {object} [options]
 * @param {string} [options.activeClass='is-active'] - класс для активной звезды
 * @param {string} [options.baseClass='icon-star'] - базовый класс звезды
 * @param {string} [options.inactiveClass] - класс для неактивной звезды (если не указан, используется baseClass)
 */
export default (rating, options = {}) => {
  const {
    activeClass = 'is-active',
    baseClass = 'icon-star',
    inactiveClass = baseClass
  } = options;

  return Array.from({ length: 5 }, (_, value) => {
    const isActive = value + 1 <= Math.round(rating) ? activeClass : '';
    const starClass = value + 1 <= Math.round(rating) ? baseClass : inactiveClass;

    return `<span class="review__rating-star ${starClass} ${isActive}"></span>`;
  });
};